import type { AutocompleteUserDataObject } from '../service';

export type AutocompleteUser = {
  canCreateModVirtualVisit?: boolean;
  description: string;
  email: string;
  firstName: string;
  hasValidModAccessToken?: boolean;
  htmlDescription: string;
  id: string;
  lastName: string;
  name: string;
  profilePhoto?: { id: string; url: string };
  superadmin?: boolean;
};

export const createAutocompleteUser = (data: AutocompleteUserDataObject): AutocompleteUser => ({
  canCreateModVirtualVisit: data.can_create_mod_virtual_visit,
  description: data.description ?? '',
  email: data.email ?? '',
  firstName: data.first_name ?? '',
  hasValidModAccessToken: data.has_valid_mod_access_token,
  htmlDescription: data.html_description ?? '',
  id: data.id,
  lastName: data.last_name ?? '',
  name: data.name ?? '',
  profilePhoto: data.profile_photo,
  superadmin: data.superadmin,
});
